import getAceCompletions from './getAceCompletions';
import { AceCompletion } from './types';

const aceCompleter: AceCompletion = {
  identifierRegexps: [
    /\./,
    /[a-zA-Z_0-9]/,
    /[\-\u00A2-\uFFFF]/,
    /a-zA-Z/,
    /\s/,
    /|/,
    /\(/,
  ],
  getCompletions: getAceCompletions,
};

export default aceCompleter;
